/**
 * <DateTime
 *	/>
 *
 * A custom wrapper for singleDatePicker and time picker
 *
 * @parent anybody
 * @stateful
 */

import React, { PropTypes } from 'react';
import classnames from 'classnames'

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { SingleDatePicker } from 'react-dates';
import './DateTime.scss';
import TimePicker from '../TimePicker2';

import moment from 'moment';

import { DEFAULT_DATE_PLACEHOLDER } from '../../constants';

import { DATE_FORMAT, TIME_FORMAT } from '../../constants';

class DateTime extends React.Component {
  static propTypes = {

  }

  constructor(props) {
    super(props);

    this.onDateChange = this.onDateChange.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);

    this.state = {
    }

    if (props.value) {
      this.state.date = moment(props.value).format(DATE_FORMAT);
      this.state.time = moment(props.value).format(TIME_FORMAT);
    }
  }


  componentWillReceiveProps(nextProps) {

    if (typeof nextProps.value === 'string') {
      this.setState({
        date: moment(nextProps.value).format(DATE_FORMAT),
        time: moment(nextProps.value).format(TIME_FORMAT),
      });
    }
  }

  onDateChange(momentDate) {
    const date = momentDate.format(DATE_FORMAT);

    let { time } = this.state;
    
    if (!time) {
      time = "12:00";
    }

    this.setState({ 
      date,
      time,
    }, ()=>{
  
      if (date && time) {
        this.props.onChange(`${date} ${time}`);
      }

    });
  }

  onTimeChange(momentTime) {
    const time = momentTime.format(TIME_FORMAT);

    let { date } = this.state;

    if (!date) {
      date = moment().format(DATE_FORMAT);
    }

    this.setState({
      date,
      time,
    }, ()=>{
      
      if (date && time) {
        this.props.onChange(`${date} ${time}`);
      }

    });
  }

  render() {
    let {
      options,
      placeholder,
      displayFormat,
      disabled
    } = this.props;

    let {
      date,
      time,
    } = this.state;

    if(options){
      delete options.enumOptions;
      delete options.emptyValue;
    }
    
    const dateToDisplay = date ? moment(date, DATE_FORMAT) : undefined;

    return (
      <div className='DateTime'>
        <div className='DatePicker form-input'>
          <SingleDatePicker
            placeholder={placeholder || DEFAULT_DATE_PLACEHOLDER}
            displayFormat={displayFormat || DATE_FORMAT}
            numberOfMonths={1}
            small={true}
            date={dateToDisplay}
            onDateChange={this.onDateChange} // PropTypes.func.isRequired
            focused={this.state.focused} // PropTypes.bool
            onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
            isOutsideRange={()=>false}
            disabled={disabled || false}
            {...options}
          />
        </div>
        <div className='TimePicker form-input'>
          <TimePicker value={moment(time, TIME_FORMAT)} onChange={this.onTimeChange} />
        </div>
      </div>
    )
  }
}

export default DateTime;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/DateTime/index.js